<template>
  <div class="audit-page">
    <!-- 标签页组件 -->
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
      <el-tab-pane label="审核" name="audit">
        <!-- 审核查询表单 - 恢复提交日期仅筛选日期 -->
        <div class="search-form">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline responsive-form">
            <el-form-item label="学校" prop="school">
              <el-select v-model="searchForm.school" placeholder="请选择学校" class="school-select" filterable clearable>
                <el-option v-for="school in schoolList" :key="school.id" :label="school.schName"
                  :value="school.schName"></el-option>
              </el-select>
            </el-form-item>

            <!-- 恢复为日期范围筛选（仅日期，不包含时分秒） -->
            <el-form-item label="提交日期">
              <el-date-picker v-model="searchForm.submitDate" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                class="date-picker-mobile" style="width: 100%;"></el-date-picker>
            </el-form-item>

            <el-form-item label="审核情况">
              <el-select v-model="searchForm.auditStatus" placeholder="请选择审核情况">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="1"></el-option>
                <el-option label="审核通过" value="0"></el-option>
                <el-option label="审核拒绝" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="身份证号">
              <el-input v-model="searchForm.idCard" placeholder="请输入学生身份证号"></el-input>
            </el-form-item>

            <el-form-item class="action-buttons">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
              <el-button type="success" icon="Download" @click="ExportApplications"
                :disabled="selectedRowKeys.length === 0" style="margin-left: 8px;">
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 申请单列表 - 卡片式展示（提交时间显示完整时分秒） -->
        <div class="application-list">
          <el-skeleton v-if="listLoading" :rows="6" animated />

          <div v-else class="card-list-container">
            <div class="card-list-header">
              <el-checkbox v-model="selectAll" @change="handleSelectAllChange"
                :indeterminate="selectedRowKeys.length > 0 && selectedRowKeys.length < applicationList.length">
                全选
              </el-checkbox>
              <span class="selected-count">已选 {{ selectedRowKeys.length }} 条</span>
            </div>

            <div v-if="applicationList.length === 0" class="empty-state">
              <el-empty description="暂无申请数据"></el-empty>
            </div>

            <div class="card-grid">
              <div v-for="row in applicationList" :key="row.id" class="application-card"
                :class="{ selected: selectedRowKeys.includes(row.id) }">
                <div class="card-content">
                  <div class="card-header">
                    <el-checkbox class="card-checkbox" :value="selectedRowKeys.includes(row.id)"
                      @change="(val) => handleCardSelectionChange(row, val)">
                      <span class="card-name">{{ row.name }}</span>
                    </el-checkbox>
                    <el-tag :type="statusType[row.auditStatus]">
                      {{ statusText[row.auditStatus] }}
                    </el-tag>
                  </div>

                  <div class="card-body">
                    <div class="card-item">
                      <span class="label">学校：</span>
                      <span class="value">{{ row.school }}</span>
                    </div>
                    <div class="card-item">
                      <span class="label">年级：</span>
                      <span class="value">{{ row.grade }}</span>
                    </div>
                    <div class="card-item">
                      <span class="label">班级：</span>
                      <span class="value">{{ row.class }}</span>
                    </div>
                    <!-- 展示完整提交时间（含时分秒），但筛选仅按日期 -->
                    <div class="card-item">
                      <span class="label">提交时间：</span>
                      <span class="value">{{ row.submitDateTime }}</span>
                    </div>
                    <div class="card-item">
                      <span class="label">身份证号：</span>
                      <span class="value">{{ row.idCard }}</span>
                    </div>
                  </div>

                  <div class="card-actions">
                    <el-button type="link" icon="el-icon-view" @click="viewDetail(row)"
                      class="link-btn">查看详情</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pagination">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="total" :page-size="pageSize"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="个人中心" name="profile">
        <div class="profile-content">
          <div class="profile-card">
            <h3>个人功能</h3>
            <!-- <div class="profile-item">
              <span class="item-label">医生签字：</span>
              <div class="item-content">
                <el-button type="primary" icon="EditPen" @click="openSignaturePad" :disabled="hasSigned">
                  医生签字
                </el-button>
                <span v-if="hasSigned" class="signed-mark">
                  <i class="el-icon-check"></i> 已完成签字
                </span>
              </div>
            </div> -->
            <div class="profile-item">
              <span class="item-label">数据导出：</span>
              <div class="item-content">
                <el-button type="success" icon="Download" @click="exportAllApplications">
                  导出全部申请数据
                </el-button>
              </div>
            </div>
            <div class="submit-btn-container">
              <van-button type="default" class="logout-btn" @click="handleLogout"
                :disabled="isUploading || isSubmitting" style="margin-top: 12px;">
                退出登录
              </van-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 医生签字弹窗 -->
    <el-dialog title="医生电子签字 (请横屏操作)" v-model="signatureDialogVisible" width="90%" height="80vh" :fullscreen="false"
      :show-close="false" custom-class="signature-dialog">
      <div class="signature-pad-container">
        <div ref="signaturePad" class="signature-pad" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
          @mouseleave="stopDrawing" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
          @touchend="handleTouchEnd">
        </div>
      </div>
      <div class="signature-actions">
        <el-button @click="clearSignature">清空</el-button>
        <el-button type="primary" @click="saveSignature" :loading="isUploadingSignature">保存签字</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import request from '@/utils/request';
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  name: 'Yishengshenhe',
  data() {
    return {
      activeTabName: 'audit',
      // 恢复searchForm提交日期为日期范围（无时分秒）
      searchForm: {
        school: '',
        submitDate: [], // 格式：['YYYY-MM-DD', 'YYYY-MM-DD']
        auditStatus: '',
        idCard: ''
      },
      applicationList: [],
      schoolList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      listLoading: false,
      statusText: {
        '0': '审核通过',
        '1': '待审核',
        '2': '审核拒绝'
      },
      statusType: {
        '0': 'success',
        '1': 'info',
        '2': 'danger'
      },
      signatureDialogVisible: false,
      hasSigned: false,
      signatureImage: '',
      isUploadingSignature: false,
      physicianPhone: '',
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      context: null,
      selectedRowKeys: [],
      selectedRows: [],
      selectAll: false,
      isUploading: false,
      isSubmitting: false
    };
  },
  mounted() {
    this.physicianPhone = localStorage.getItem('physicianPhone') || '';
    if (localStorage.getItem('doctorSignature')) {
      this.hasSigned = true;
      this.signatureImage = localStorage.getItem('doctorSignature');
    }
    this.fetchApplicationList();
  },
  created() {
    this.fetchSchoolList();
  },
  methods: {
    handleTabClick(tab, event) {
      console.log(tab, event);
    },
    fetchSchoolList() {
      request({
        url: '/api/schoolInfos/allPhysician',
        method: 'get',
      }).then(response => {
        if (response.code === 200 && Array.isArray(response.data)) {
          this.schoolList = response.data;
        } else {
          ElMessage.error('获取学校列表失败');
        }
      }).catch(error => {
        ElMessage.error('获取学校列表失败');
        console.error('获取学校列表失败:', error);
      });
    },
    fetchApplicationList() {
      this.listLoading = true;
      request({
        url: '/api/review/listAll',
        method: 'get',
        headers: {
          "accept": "application/json, text/plain, */*",
          "content-type": "application/json"
        },
        withCredentials: false,
        timeout: 10000
      }).then(response => {
        this.listLoading = false;
        let resData = typeof response === 'string' ? JSON.parse(response) : response;
        if (resData.code !== 200 || !Array.isArray(resData.data)) {
          ElMessage.error(`获取申请单列表失败: ${resData.message || '服务器未返回有效数据'}`);
          this.applicationList = [];
          this.total = 0;
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.selectAll = false;
          return;
        }

        // 筛选逻辑：提交日期仅按日期筛选（自动忽略后端时间的时分秒）
        let filteredList = resData.data.filter(item => {
          // 学校筛选
          if (this.searchForm.school && item.reChildrenSchool !== this.searchForm.school) return false;
          // 审核状态筛选
          if (this.searchForm.auditStatus !== '' && item.reStatus.toString() !== this.searchForm.auditStatus) return false;
          // 身份证号筛选
          if (this.searchForm.idCard && item.reChildrenSfz !== this.searchForm.idCard) return false;
          // 提交日期筛选：仅对比日期部分（忽略时分秒）
          if (this.searchForm.submitDate && this.searchForm.submitDate[0]) {
            // 1. 提取后端时间的日期部分（YYYY-MM-DD）
            const itemDate = this.formatDate(item.createTime || item.queCreateTime || item.submitDate, false);
            // 2. 筛选开始/结束日期（已为YYYY-MM-DD格式）
            const startDate = this.searchForm.submitDate[0];
            const endDate = this.searchForm.submitDate[1] || startDate;
            // 3. 日期字符串对比（确保筛选当天及范围内的数据）
            if (itemDate < startDate || itemDate > endDate) return false;
          }
          return true;
        });

        // 格式化数据：同时保留日期和完整时间字段
        this.applicationList = this.formatApplicationList(filteredList);
        // 按完整提交时间倒序排序（最新的在前）
        this.applicationList.sort((a, b) => {
          return new Date(b.submitDateTime) - new Date(a.submitDateTime);
        });

        // 分页处理
        this.total = this.applicationList.length;
        const startIndex = (this.currentPage - 1) * this.pageSize;
        this.applicationList = this.applicationList.slice(startIndex, startIndex + this.pageSize);

      }).catch(error => {
        this.listLoading = false;
        const errorMsg = error.message.includes('CORS')
          ? '获取数据失败：跨域配置异常，请联系管理员'
          : '获取数据失败：网络异常或服务器错误';
        ElMessage.error(errorMsg);
        console.error('调用 /api/review/listAll 失败:', error);
        this.applicationList = [];
        this.total = 0;
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.selectAll = false;
      });
    },
    // 格式化列表数据：同时生成日期字段（submitDate）和完整时间字段（submitDateTime）
    formatApplicationList(rawList) {
      if (!Array.isArray(rawList)) return [];
      return rawList.map(item => {
        const rawTime = item.createTime || item.queCreateTime || item.submitDate;
        return {
          id: item.id || item.reId || item.queId || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          name: item.reChildrenName || item.queChildrenName || item.childrenName || '未知姓名',
          school: item.reChildrenSchool || item.queChildrenSchool || item.school || '未知学校',
          grade: item.reChildrenGrade || item.queChildrenGrade || item.grade || '未知年级',
          class: item.reChildrenClass || item.queChildrenClass || item.class || '未知班级',
          // 仅日期（用于筛选逻辑）
          submitDate: this.formatDate(rawTime, false),
          // 完整时间（含时分秒，用于页面展示）
          submitDateTime: this.formatDate(rawTime, true),
          auditStatus: (item.reStatus ?? item.queStatus ?? item.auditStatus ?? '').toString(),
          idCard: item.reChildrenSfz || item.queChildrenSfz || item.childrenSfz || '未填写',
          // 保留原始字段，便于后续操作
          rawId: item.id,
          rawReId: item.reId,
          rawQueId: item.queId,
          reChildrenName: item.reChildrenName,
          reChildrenSchool: item.reChildrenSchool,
          reChildrenGrade: item.reChildrenGrade,
          reChildrenClass: item.reChildrenClass,
          reStatus: item.reStatus,
          createTime: item.createTime
        };
      });
    },
    // 日期格式化工具：支持两种模式（仅日期/完整时间）
    formatDate(dateStr, showTime = false) {
      if (!dateStr) return showTime ? '未知时间' : '未知日期';
      // 处理时间戳格式（兼容10位/13位时间戳）
      if (typeof dateStr === 'number') {
        dateStr = dateStr.toString().length === 13 ? dateStr : dateStr * 1000;
      }
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return showTime ? '时间格式错误' : '日期格式错误';

      // 基础日期格式化（YYYY-MM-DD）
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      // 仅返回日期（用于筛选）
      if (!showTime) {
        return `${year}-${month}-${day}`;
      }

      // 返回完整时间（含时分秒，用于展示）
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 查询按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectAll = false;
      this.fetchApplicationList();
    },
    // 重置表单
    resetForm() {
      this.searchForm = {
        school: '',
        submitDate: [], // 重置为日期范围（无时分秒）
        auditStatus: '',
        idCard: ''
      };
      this.currentPage = 1;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectAll = false;
      this.fetchApplicationList();
    },
    // 查看详情
    viewDetail(row) {
      console.log('查看详情-当前行数据:', row);
      if (!row) {
        ElMessage.error('行数据为空无法查看详情');
        return;
      }
      const detailId = row.id;
      if (!detailId) {
        ElMessage.warning('该记录无有效ID，无法查看详情');
        console.warn('无效的审核单ID:', detailId);
        return;
      }
      try {
        const jumpSuccess = this.$router.push({
          path: '/applicationdetail',
          query: { id: detailId }
        });
        if (jumpSuccess && jumpSuccess.catch) {
          jumpSuccess.catch(error => {
            console.error('跳转详情页失败（Promise捕获）:', error);
            this.handleRouteError(error);
          });
        }
      } catch (error) {
        console.error('跳转详情页失败（try-catch捕获）:', error);
        this.handleRouteError(error);
      }
    },
    // 路由错误处理
    handleRouteError(error) {
      if (error.message.includes('Cannot find module')) {
        ElMessage.error('跳转失败：详情页组件未找到，请检查组件路径是否正确');
      } else if (error.message.includes('Route with name') || error.message.includes('path')) {
        ElMessage.error('跳转失败：详情页路由未注册，请检查router/index.js配置');
      } else if (error.message.includes('NavigationDuplicated')) {
        ElMessage.warning('已在详情页，无需重复跳转');
      } else {
        ElMessage.error(`跳转失败：${error.message || '未知错误'}`);
      }
    },
    // 审核状态更新
    updateAuditStatus(reId, status, statusText) {
      request({
        url: '/api/review/updateStatus',
        method: 'put',
        data: { reId, reStatus: status }
      }).then(response => {
        if (response.code === 200) {
          ElMessage.success(`已${statusText}该申请`);
          this.fetchApplicationList();
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.selectAll = false;
        } else {
          ElMessage.error(`${statusText}失败：${response.message || '服务器错误'}`);
        }
      }).catch(error => {
        ElMessage.error(`${statusText}失败：网络异常`);
        console.error(`${statusText}接口调用失败:", error`);
      });
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectAll = false;
      this.fetchApplicationList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectAll = false;
      this.fetchApplicationList();
    },
    // 打开签字弹窗
    openSignaturePad() {
      if (!this.physicianPhone) {
        ElMessage.error('未获取到医生登录信息，请重新登录');
        return;
      }
      this.signatureDialogVisible = true;
      this.$nextTick(() => this.initSignaturePad());
    },
    // 初始化签字画布
    initSignaturePad() {
      const canvas = document.createElement('canvas');
      const pad = this.$refs.signaturePad;
      canvas.width = pad.clientWidth > 0 ? pad.clientWidth : 300;
      canvas.height = pad.clientHeight > 0 ? pad.clientHeight : 200;
      pad.innerHTML = '';
      pad.appendChild(canvas);
      this.context = canvas.getContext('2d');
      this.context.lineWidth = 5;
      this.context.lineCap = 'round';
      this.context.strokeStyle = '#000000';
    },
    // 开始绘制 (PC)
    startDrawing(e) {
      this.isDrawing = true;
      [this.lastX, this.lastY] = [e.offsetX, e.offsetY];
    },
    // 绘制中 (PC)
    draw(e) {
      if (!this.isDrawing) return;
      this.context.beginPath();
      this.context.moveTo(this.lastX, this.lastY);
      this.context.lineTo(e.offsetX, e.offsetY);
      this.context.stroke();
      [this.lastX, this.lastY] = [e.offsetX, e.offsetY];
    },
    // 结束绘制 (PC)
    stopDrawing() {
      this.isDrawing = false;
    },
    // 触摸事件 (移动端)
    handleTouchStart(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const rect = this.$refs.signaturePad.getBoundingClientRect();
      this.startDrawing({
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top
      });
    },
    handleTouchMove(e) {
      e.preventDefault();
      const touch = e.touches[0];
      const rect = this.$refs.signaturePad.getBoundingClientRect();
      this.draw({
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top
      });
    },
    handleTouchEnd(e) {
      e.preventDefault();
      this.stopDrawing();
    },
    // 清空画布
    clearSignature() {
      this.initSignaturePad();
    },
    // dataURL转Blob
    dataURLToBlob(dataURL) {
      if (!dataURL || typeof dataURL !== 'string' || !dataURL.startsWith('data:')) {
        console.error('无效的 dataURL:', dataURL);
        return null;
      }
      const arr = dataURL.split(',');
      if (arr.length < 2) {
        console.error('dataURL 格式错误:', dataURL);
        return null;
      }
      const matchResult = arr[0].match(/:(.*?);/);
      const mime = matchResult ? matchResult[1] : 'image/png';
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 保存签字
    async saveSignature() {
      const canvas = this.$refs.signaturePad.querySelector('canvas');
      if (!canvas) {
        ElMessage.error('签字画布未初始化！');
        return;
      }
      const isCanvasEmpty = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data.every(byte => byte === 0);
      if (isCanvasEmpty) {
        ElMessage.warning('请先在画布上签字再保存。');
        return;
      }
      if (!this.physicianPhone) {
        ElMessage.error('未获取到医生登录信息，无法上传签字');
        return;
      }
      this.isUploadingSignature = true;
      try {
        const dataURL = canvas.toDataURL('image/png');
        if (!dataURL) {
          throw new Error('获取 canvas dataURL 失败');
        }
        const blob = this.dataURLToBlob(dataURL);
        if (!blob) {
          throw new Error('将 dataURL 转换为 Blob 对象失败');
        }
        const formData = new FormData();
        formData.append('psId', this.physicianPhone);
        formData.append('file', blob, 'doctor_signature.png');
        const response = await request({
          url: '/api/physicians/uploadSignature',
          method: 'post',
          data: formData,
        });
        if (response.code === 200) {
          this.signatureImage = dataURL;
          localStorage.setItem('doctorSignature', this.signatureImage);
          this.hasSigned = true;
          this.signatureDialogVisible = false;
          ElMessage.success('签名上传成功！');
        } else {
          ElMessage.error(`签名上传失败：${response.message || '服务器错误'}`);
        }
      } catch (error) {
        ElMessage.error('签名上传失败：处理图像数据时发生错误');
        console.error('签字上传失败:', error);
      } finally {
        this.isUploadingSignature = false;
      }
    },
    // Blob文件下载
    downloadFileFromBlob(blob, fileName) {
      if (!blob || !(blob instanceof Blob)) {
        ElMessage.error('文件数据无效，无法下载');
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    // 通用导出函数
    async handleExport(idCardList, fileName) {
      try {
        ElMessage.info(`正在导出数据，请稍候...`);
        console.log('--- 开始导出 ---', { idCardList, fileName });
        const response = await request({
          url: '/api/review/exportToExcel',
          method: 'post',
          data: { idCardList },
          responseType: 'blob',
        });
        this.downloadFileFromBlob(response.data, fileName);
        ElMessage.success('数据导出成功！');
        console.log('--- 导出完成 ---');
      } catch (error) {
        console.error('--- 导出失败 ---', error);
        if (error.response) {
          console.error('响应状态码:', error.response.status);
          console.error('响应数据:', error.response.data);
          if (error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const errorMsg = JSON.parse(e.target.result);
                ElMessage.error(`导出失败：${errorMsg.message || '服务器内部错误'}`);
              } catch (parseErr) {
                ElMessage.error('导出失败，请检查控制台日志或联系管理员');
              }
            };
            reader.readAsText(error.response.data);
          } else {
            ElMessage.error(`导出失败：${error.response.data?.message || '服务器内部错误'}`);
          }
        } else if (error.request) {
          ElMessage.error('导出失败：网络连接异常，请重试');
        } else {
          ElMessage.error(`导出失败：${error.message}`);
        }
      }
    },
    // 导出选中数据
    async ExportApplications() {
      if (this.selectedRows.length === 0) {
        ElMessage.warning('请先选择要导出的申请单');
        return;
      }
      const idCardList = this.selectedRows
        .map(row => row.idCard)
        .filter(idCard => idCard && idCard !== '未填写');
      if (idCardList.length === 0) {
        ElMessage.warning('选中的记录中无有效身份证号，无法导出');
        return;
      }
      const fileName = `选中${this.selectedRows.length}条记录_申请数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
      await this.handleExport(idCardList, fileName);
    },
    // 导出全部数据
    async exportAllApplications() {
      const fileName = `全部申请数据_${new Date().toISOString().slice(0, 10)}.xlsx`;
      await this.handleExport([], fileName);
    },
    // 卡片选择变化
    handleCardSelectionChange(row, val) {
      if (!row || !row.id) return;
      if (val) {
        if (!this.selectedRowKeys.includes(row.id)) {
          this.selectedRowKeys.push(row.id);
        }
      } else {
        const index = this.selectedRowKeys.indexOf(row.id);
        if (index > -1) {
          this.selectedRowKeys.splice(index, 1);
        }
      }
      this.selectedRows = this.applicationList.filter(item => this.selectedRowKeys.includes(item.id));
      this.selectAll = this.applicationList.length > 0 && this.selectedRowKeys.length === this.applicationList.length;
    },
    // 全选处理
    handleSelectAllChange(val) {
      const listLength = this.applicationList.length;
      if (listLength === 0) {
        ElMessage.warning('当前无数据可选择');
        this.selectAll = false;
        return;
      }
      if (val) {
        this.selectedRowKeys = this.applicationList.map(item => item.id);
        this.selectedRows = [...this.applicationList];
      } else {
        this.selectedRowKeys = [];
        this.selectedRows = [];
      }
    },
    // 退出登录
    handleLogout() {
      ElMessageBox.confirm(
        '确定要退出登录吗？未保存的数据可能会丢失',
        '退出提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        // 清除本地存储
        localStorage.removeItem('userToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('bingliCompleted');
        localStorage.removeItem('xinxiCompleted');
        localStorage.removeItem('zhengmingCompleted');
        localStorage.removeItem('uploadedFilePath');
        localStorage.removeItem('uploadedFileName');
        localStorage.removeItem('apiResponseData');
        localStorage.removeItem('missingFields');
        // 清除Vuex角色状态
        if (this.$store && this.$store.commit) {
          this.$store.commit('clearUserRoles');
        }
        // 拼接hopId参数跳转登录页
        const hopId = localStorage.getItem('hopId') || '';
        const routeConfig = {
          path: '/denglu',
          replace: true
        };
        if (hopId) {
          routeConfig.query = { hopId };
        }
        this.$router.push(routeConfig).then(() => {
          if (this.$toast) {
            this.$toast.success('退出登录成功', { duration: 2000 });
          } else {
            ElMessage.success('退出登录成功');
          }
        });
      }).catch(() => {
        if (this.$toast) {
          this.$toast.info('已取消退出', { duration: 1500 });
        } else {
          ElMessage.info('已取消退出');
        }
      });
    }
  }
};
</script>

<style scoped>
.audit-page {
  padding: 20px;
  background-color: #f9f9f9;
  min-height: calc(100vh - 60px);
}

.search-form {
  background-color: lightblue;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.application-list {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.card-list-container {
  width: 100%;
}

.card-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.selected-count {
  color: #666;
  font-size: 14px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.application-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
  position: relative;
  background-color: #fff;
}

.application-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #e6f7ff;
}

.application-card.selected {
  border-color: #1890ff;
  background-color: #f0f8ff;
}

.card-content {
  width: 100%;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #f0f0f0;
  gap: 8px;
}

:deep(.card-checkbox .el-checkbox__label) {
  padding-left: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  flex: 1;
}

:deep(.card-checkbox .el-checkbox__inner) {
  width: 18px;
  height: 18px;
}

.card-body {
  margin-bottom: 16px;
}

.card-item {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.card-item:last-child {
  margin-bottom: 0;
}

.card-item .label {
  color: #666;
  width: 70px;
  flex-shrink: 0;
}

.card-item .value {
  color: #333;
  flex: 1;
  word-break: break-all;
}

.card-actions {
  text-align: right;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

.profile-content {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 120px);
}

.profile-card {
  width: 100%;
  max-width: 600px;
  padding: 30px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.profile-card h3 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-size: 18px;
}

.profile-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #ebeef5;
}

.profile-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.item-label {
  display: inline;
  width: 100px;
  font-weight: 500;
  color: #666;
  text-align: right;
  margin-right: 20px;
}

.item-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.signed-mark {
  margin-left: 15px;
  color: #67c23a;
}

.signed-mark i {
  margin-right: 5px;
}

.signature-dialog .el-dialog__body {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
}

.signature-pad-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
  padding: 20px;
}

.signature-pad {
  width: 100%;
  height: 100%;
  border: 2px dashed #ccc;
  background-color: #fff;
  cursor: crosshair;
}

.signature-actions {
  padding: 15px 20px;
  text-align: right;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

@media (max-width: 768px) {
  .search-form {
    padding: 15px;
  }

  :deep(.responsive-form) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 12px;
  }

  :deep(.responsive-form .el-form-item) {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  :deep(.responsive-form .el-form-item__label) {
    width: 70px;
    flex-shrink: 0;
    text-align: right;
    padding-right: 10px;
  }

  :deep(.responsive-form .el-form-item__content) {
    flex: 1;
  }

  :deep(.responsive-form .el-input),
  :deep(.responsive-form .el-select),
  :deep(.responsive-form .el-date-picker) {
    width: 100% !important;
  }

  :deep(.responsive-form .action-buttons) {
    justify-content: center;
    padding-top: 10px;
  }

  .card-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .application-card {
    padding: 12px;
  }

  .profile-card {
    padding: 20px 15px;
  }

  .profile-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .item-label {
    width: auto;
    text-align: left;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .logout-btn {
    background-color: #f5f5f5;
    color: #ff4d4f;
    border: 1px solid #ff4d4f;
  }

  .logout-btn:hover {
    background-color: #fff2f0;
  }
}
</style>